import React from "react";
import Tittle from "../Components/Tittle";
import allProjects from "../Components/allProjects";
import translate from "../Translation/i18nProvider/translate";

function ProjectsPage() {
  return (
    <div>
      <div className="b-title">
        <Tittle title={translate("project_main_title")}/>
      </div>
      <div className="ProjectsPage">
        {allProjects.map((project) => {
          return (
            <div className="project" key={project.id}>
              <div className="project-content">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={project.link}
                  className="project-link"
                >
                  <img src={project.image} alt="" /> 
                </a>
                <div>
                <a
                    target="_blank"
                    rel="noreferrer"
                    href={project.link}
                    className="project-link-title"
                  >
                    {project.title}
                  </a> <br></br>
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={project.linkSourse}
                    className="project-link-sourse"
                  >
                    {project.titleSourse}
                  </a>
                </div>
                <div className="project-description">{project.description}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default ProjectsPage;
